import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'proforma-invoice',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER_GENERAL_DATA":[
            // { index: 1, name: ['手动推送'], icon: 'fas fa-paper-plane', check_lines: 0, on_click: [], sign: 'sendOrder', },
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'proforma-invoice-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'proformaInvoice/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
    }
}
const state = () => ({
    proformaInvoice: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.proformaInvoice.pageConfig,
    getPageConfigTree: state => state.proformaInvoice.pageConfigTree,
    getPageKey:state => state.proformaInvoice.pageKey,
    getPushDataDialog:state => state.proformaInvoice.dialogPage,
    getPushDataPageKey:state => state.proformaInvoice.dialogPage.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.proformaInvoice.resetPage = data;
    },
    setLoading(state, data){
        state.proformaInvoice.loading = data;
        if(isNotEmpty(state.proformaInvoice.pageConfig)){
            Object.keys(state.proformaInvoice.pageConfig).forEach((key,index)=>{
                state.proformaInvoice.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.proformaInvoice.pageConfig = data.pageConfig;
        state.proformaInvoice.pageConfigTree = data.allArrData;
        state.proformaInvoice.pageKey = getRandomString();
        if(isNotEmpty(state.proformaInvoice.pageConfig)){
            Object.keys(state.proformaInvoice.pageConfig).forEach((key,index)=>{
                state.proformaInvoice.pageConfig[key].height = state.proformaInvoice.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.proformaInvoice.dialogPage.pageConfig = data.pageConfig;
        state.proformaInvoice.dialogPage.pageConfigTree = data.allArrData;
        state.proformaInvoice.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.proformaInvoice.dialogPage.pageConfig)){
            Object.keys(state.proformaInvoice.dialogPage.pageConfig).forEach((key,index)=>{
                state.proformaInvoice.dialogPage.pageConfig[key].height = state.proformaInvoice.height
            })
        }
    },
    setPushDialogList(state, data){
        state.proformaInvoice.dialogPage.pageConfig[data.obj].data = data.data;
        state.proformaInvoice.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.proformaInvoice.pageConfig[data.obj].data = data.data;
        state.proformaInvoice.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.proformaInvoice.height = (data-50) + 'px';
        if(isNotEmpty(state.proformaInvoice.pageConfig)){
            Object.keys(state.proformaInvoice.pageConfig).forEach((key,index)=>{
                state.proformaInvoice.pageConfig[key].height = state.proformaInvoice.height;
            })
        }
        state.proformaInvoice.dialogPage.height = (data-50) + 'px';
        if(isNotEmpty(state.proformaInvoice.dialogPage.pageConfig)){
            Object.keys(state.proformaInvoice.dialogPage.pageConfig).forEach((key,index)=>{
                state.proformaInvoice.dialogPage.pageConfig[key].height = state.proformaInvoice.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.proformaInvoice.pageConfig,pageConfigTree:state.proformaInvoice.pageConfigTree});
    }
}
const actions = {
    ['handlePushData']({ state, dispatch, rootState ,commit}, payload) {
        state.proformaInvoice.dialogPage.colseDialogFun = payload.colseDialogFun;
        if(state.proformaInvoice.dialogPage.isPushIng){
            dispatch('response/negative', { message: '推送数据处理中，请误重复操作！' }, { root: true })
            return
        }
        state.proformaInvoice.dialogPage.isPushIng = true;
        let msg = { command: "post_client__inventory_push",message: {},to: "client",'is_not_net_request':true}
        dispatch('response/info-tip', { message: '推送开始请耐心等待。。。' }, { root: true })
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['pushDataReturn']({ state, commit,dispatch }, payload) {
        state.proformaInvoice.dialogPage.isPushIng = false;
        state?.proformaInvoice?.dialogPage?.colseDialogFun();
        if (payload.success) {
            dispatch('response/success-tip', { message: '推送成功' }, { root: true })
            state?.proformaInvoice?.resetPage({});
        }
    },
    async ['fetch-push-data-list']({ state, dispatch, rootState ,commit}, payload) {
        state.proformaInvoice.dialogPage.pageConfig = {};
        state.proformaInvoice.dialogPage.pageConfigTree = [];
        let msg = { command: "post_client__inventory_push_data",message: {},to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async['return_list-push-data']({ state, commit }, payload) {
        if (payload.success) {
            let pageData = setPageConfig({
                pageData:payload.data.objs,
                tableName:state.proformaInvoice.dialogPage.tableName,
                top_tools:state.proformaInvoice.dialogPage.top_tools,
                isFalsePagination:state.proformaInvoice.dialogPage.isFalsePagination
            });
            commit('setPushDialogConfig',pageData);
            let myCoums = await getMyColums({name:state.proformaInvoice.dialogPage.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.proformaInvoice.dialogPage.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setPushDialogList',payload.data);
        }
    },


    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.proformaInvoice.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__invoice", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            let params = JSON.parse(JSON.stringify(payload));
            if(!isNotEmpty(state.proformaInvoice.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.proformaInvoice.tableName,top_tools:state.proformaInvoice.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.proformaInvoice.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.proformaInvoice.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__invoice_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
